export default {
  namespaced: true,
  state: {
    panoramaStatus: false,
  },
  mutations: {
    setPanoramaStatus(state, payload) {
      state.panoramaStatus = payload;
    },
  },
  actions: {
    setPanoramaStatus({ commit }, value) {
      commit("setPanoramaStatus", value);
    },
  },
  getters: {
    panoramaStatus: (state) => state.panoramaStatus,
  },
};
